<template>
  <div class="main-content-container overflow-hidden">
    <PageTitle pageTitle="Form Ship Management Company" subTitle="Forms" />

    <CreateShipManagementCompany />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PageTitle from "@/components/Common/PageTitle.vue";
import CreateShipManagementCompany from "@/components/Pages/Master/ShipManagementCompany/CreateShipManagementCompany.vue";

export default defineComponent({
  name: "CreateShipManagementCompanyPage",
  components: {
    PageTitle,
    CreateShipManagementCompany,
  },
});
</script>
